import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const MagicWand = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path d="M17 5V3H19V5H21V7H19V9H17V7H15V5H17Z" fill="currentColor" />
    <path
      clipRule="evenodd"
      d="M13.9142 8.91416C13.1331 8.13311 11.8668 8.13311 11.0857 8.91416L2.91416 17.0857C2.13311 17.8668 2.13311 19.1331 2.91416 19.9142L4.08573 21.0857C4.86678 21.8668 6.13311 21.8668 6.91416 21.0857L15.0857 12.9142C15.8668 12.1331 15.8668 10.8668 15.0857 10.0857L13.9142 8.91416ZM10.8713 11.957L12.4999 10.3284L13.6715 11.4999L12.0428 13.1286L10.8713 11.957ZM9.45705 13.3713L4.32837 18.4999L5.49994 19.6715L10.6286 14.5428L9.45705 13.3713Z"
      fill="currentColor"
      fillRule="evenodd"
    />
    <path d="M17 13V14.5H15.5V16.5H17V18H19V16.5H20.5V14.5H19V13H17Z" fill="currentColor" />
    <path d="M7.5 5V3.5H9.5V5H11V7H9.5V8.5H7.5V7H6V5H7.5Z" fill="currentColor" />
  </Icon>
));

export default MagicWand;
